import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import Toggle from 'components/ReusableComponents/Toggle'
import { parentChainNames } from 'main/hotelBrandsAndChains'
import canadianProvinces from 'static/addresses/canadianProvinces'
import usStates from 'static/addresses/usStates'

import {
  getBrandDisplayOptions,
  getGroupDisplayOptions
} from '../../MonthlyRevenue/utils/hotelHelpers'
import styles from '../MonthlyOTAConversions.module.scss'

export const OTAConversionsFilters = ({
  isOtaOnly,
  setIsOTAOnly,
  isInternalAdmin,
  showAllHotels,
  showWholeGroup,
  stateToFilter,
  handleChangeState,
  availableCities,
  cityToFilter,
  setCityToFilter,
  parentChain,
  setParentChain,
  hotelGroups,
  handleChangeGroupFilter,
  activeYear,
  setActiveYear,
  years,
  isDemoMode
}) => {
  return (
    <div className={styles.dropdowns}>
      <Toggle
        label="Only show OTAs"
        checked={isOtaOnly}
        handleChange={e => setIsOTAOnly(e.target.checked)}
      />
      {isInternalAdmin && (showAllHotels || showWholeGroup) && (
        <Dropdown
          label="State/Province"
          options={{ '': ' Any state', ...usStates, ...canadianProvinces }}
          value={stateToFilter}
          onChange={e => handleChangeState(e.target.value)}
        />
      )}
      {isInternalAdmin && (showAllHotels || showWholeGroup) && (
        <Dropdown
          label="City"
          options={{
            '': ' Any city',
            ...availableCities
          }}
          value={cityToFilter}
          onChange={e => setCityToFilter(e.target.value)}
          defaultValue="Any city"
        />
      )}
      {isInternalAdmin && (showAllHotels || showWholeGroup) && (
        <Dropdown
          label="Brand"
          options={getBrandDisplayOptions(parentChainNames, isDemoMode)}
          value={parentChain}
          onChange={e => setParentChain(e.target.value)}
          isDemoMode={isDemoMode}
        />
      )}
      {isInternalAdmin && (
        <Dropdown
          options={getGroupDisplayOptions(hotelGroups, isDemoMode)}
          defaultValue="currentHotel"
          label="Hotel group & level"
          onChange={e => handleChangeGroupFilter(e.target.value)}
          isDemoMode={isDemoMode}
        />
      )}
      <Dropdown
        label="Year"
        className={styles.datepickerDropdown}
        value={activeYear}
        onChange={e => setActiveYear(e.target.value)}
        options={years.reduce((acc, year) => {
          acc[year] = year
          return acc
        }, {})}
      />
    </div>
  )
}
